import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

import { LoadingButton } from './LoadingButton';

type SectionProps = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    /** Shows the Refresh button, which reloads what the page displays. */
    onRefresh?: () => void;
    /** True while the page is reloading: the Refresh button locks and spins. */
    refreshing?: boolean;
    children: React.ReactNode;
};

export function Section({ title, subtitle, onRefresh, refreshing = false, children }: SectionProps) {
    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, position: 'relative' }}>
            {onRefresh && (
                <LoadingButton
                    onClick={onRefresh}
                    loading={refreshing}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    Refresh
                </LoadingButton>
            )}
            <Typography
                variant="overline"
                color="text.secondary"
                sx={{ display: 'block', lineHeight: 1.6 }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: 'block' }}
                >
                    {subtitle}
                </Typography>
            )}
            <Box sx={{ mt: '30px' }}>{children}</Box>
        </Paper>
    );
}
